import {GET_ACTIVE_LOGISTICS_OPTIONS, GET_LOGISTICS_OPTIONS} from "@/store/action-types";
import {getLogisticsOptions} from "@/api/logistics";

const SET_LOGISTICS_OPTIONS = 'SET_LOGISTICS_OPTIONS';
const SET_ACTIVE_LOGISTICS_OPTIONS = 'SET_ACTIVE_LOGISTICS_OPTIONS';

const state = {
  logisticsOption: null,
  activeLogisticsOption: null,
};

const mutations = {
  [SET_LOGISTICS_OPTIONS](state, data) {
    state.logisticsOption = data;
  },
  [SET_ACTIVE_LOGISTICS_OPTIONS](state, data) {
    state.activeLogisticsOption = data;
  },
};

const actions = {
  // 获取物流商
  [GET_LOGISTICS_OPTIONS]({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      getLogisticsOptions({})
        .then((data) => {
          commit(SET_LOGISTICS_OPTIONS, data || []);
          resolve();
        })
        .catch(() => reject());
    });
  },
  // 获取启用物流商
  [GET_ACTIVE_LOGISTICS_OPTIONS]({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      getLogisticsOptions({isActive: true})
        .then((data) => {
          commit(SET_ACTIVE_LOGISTICS_OPTIONS, data || []);
          resolve();
        })
        .catch(() => reject());
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
